import React, { FC, useCallback, useMemo } from 'react';
import { StyledBackToGameButton } from './style';
import { DeepLink } from 'utils/types';
import { getReturnToGameLinkAddress } from 'components/BackToGameButton/utils';

type BackToGameButtonProps = {
  deepLinks?: DeepLink[];
  buttonImage?: string;
  isMockPreview?: boolean;
};

export const CustomBackToGameButton: FC<BackToGameButtonProps> = ({
  deepLinks = [],
  buttonImage = '',
  isMockPreview = false,
}) => {
  const returnToGameLinkAddress = useMemo(
    () =>
      deepLinks && deepLinks.length > 0
        ? getReturnToGameLinkAddress(deepLinks)
        : '',
    [deepLinks],
  );

  const handleBackToGame = useCallback(() => {
    if (!returnToGameLinkAddress) return;

    window.location.assign(returnToGameLinkAddress);
  }, [returnToGameLinkAddress]);

  if (isMockPreview) {
    if (!buttonImage) return null;
  } else {
    if (!buttonImage || !returnToGameLinkAddress) return null;
  }

  return (
    <StyledBackToGameButton
      onClick={handleBackToGame}
      src={buttonImage}
      alt="backToGame"
    />
  );
};
